import { useSelector } from 'react-redux';
import { selectEstimationTarget } from '../../../selectors';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';
import { useIsDesktop } from '@cian/valuation-utils-component';

export const useButtonText = (): string => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return 'Добавить объект';
  }

  switch (estimationTarget) {
    case EMyHomeEstimationTargets.house:
      return 'Добавить дом';

    case EMyHomeEstimationTargets.land:
      return 'Добавить участок';

    default:
      return 'Добавить квартиру';
  }
};
